import { createContext, useContext } from 'react';

export type DateTypes = 'today' | 'last48hours' | 'last7days' | 'last30days' | 'custom';

interface DateContextType {
  selectedDate: {
    startDate: string;
    endDate: string;
  };
  handleDateChange: (date: DateTypes) => void;
  customDateChange: ({ startDate, endDate }: { startDate: string; endDate: string }) => void;
  dateType: DateTypes;
  handleDateTypeChange: (dateType: DateTypes) => void;
}

export const DateContext = createContext<DateContextType | undefined>(undefined);

export const useDate = () => {
  const context = useContext(DateContext);
  if (context === undefined) {
    throw new Error('useDate must be used within a DateProvider');
  }
  return context;
};
